import React from 'react';
import Typography from '@mui/material/Typography';
import Constants from 'style/constants';

import styles from 'features/residents/resident-change-logs/views/components/columns/user-column/user-column.module.scss';

type Props = {
  userFullName: string;
};

const UserColumn = ({ userFullName }: Props): React.JSX.Element => {
  return (
    <div className={styles.container}>
      <div className={styles.avatar}>
        <Typography variant="overline" sx={{ color: Constants.Colors.onSurfaceVariant }} className={styles.name}>
          {`${userFullName?.split(' ').shift()?.charAt(0)}${userFullName?.split(' ').pop()?.charAt(0)}`}
        </Typography>
      </div>
      <Typography variant="overline" sx={{ color: Constants.Colors.onSurfaceVariant }} className={styles.name}>
        {userFullName}
      </Typography>
    </div>
  );
};

export default UserColumn;
